import { Avatar, Button, Group, Title } from "@mantine/core";
import { useClipboard } from "@mantine/hooks";
import { showNotification } from "@mantine/notifications";
import React, { useState } from "react";
import { GET_COMPANY_INTEGRATION, SET_COMPANY_INTEGRATION } from "../../services/companies";
import InputField from "../input_field";
import { FaCodeBranch } from "react-icons/fa";

export default function External(){
    const [data, setData] = useState<any>(null);
    const [loadingSave, setLoadingSave] = useState<boolean>(false);

    const clipboard = useClipboard();

    // const handleChange = dt => setData(u => ({ ...u, ...dt }))

    const loadData = () => {
        GET_COMPANY_INTEGRATION("external")
        .then((res) => {
            setData(res)
        })
        .catch(err => {
            showNotification({title: "Ops.", message: err.message, color: 'red'})
        })
    }
    
    const handleSave = () => {
        setLoadingSave(true)
        
        SET_COMPANY_INTEGRATION("external", {...data}, [{key: "key"}])
        .then((res) => {
            setLoadingSave(false);
            loadData()
            showNotification({message: "Re-generated external API KEY", color: 'green'})
        })
        .catch(err => {
            setLoadingSave(false)
            showNotification({title: "Ops.", message: err.message, color: 'red'})
        })
    }

    React.useEffect(() => { loadData() }, [])

    return <>
        <Group>
            <FaCodeBranch />
            <Title order={5}>Api Externa</Title>
        </Group>
        <Group align="flex-end">
            <InputField
                mt="md"
                name="key"
                style={{flex: 1}}
                value={data?.key}
                disabled
                title="API KEY"
            />
            <Button size="sm" onClick={() => {
                clipboard.copy(data?.key);
                showNotification({ message: "Copiado para a área de transferência", color: "yellow" })
            }} color="gray">Copiar</Button>
        </Group>

        <Group position='right' mt="md">
            <Button size="sm" onClick={handleSave} loading={loadingSave} color="green">Gerar novamente</Button>
        </Group>
    </>
}
